import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CachedInstagramAccount {
  id: string;
  user_id: string;
  ad_account_id: string | null;
  instagram_id: string;
  username: string;
  display_name: string;
  linked_page_id: string | null;
  last_synced_at: string | null;
  created_at: string | null;
}

export function useCachedInstagramAccounts(userId: string | undefined, options?: { refetchInterval?: number | false | ((query: any) => number | false) }) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["cached-instagram-accounts", userId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("meta_cached_instagram_accounts")
        .select("*")
        .eq("user_id", userId!)
        .order("username");

      if (error) throw error;
      return data as CachedInstagramAccount[];
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    refetchInterval: options?.refetchInterval ?? ((query) => {
      const currentData = query.state.data;
      if (!currentData || currentData.length === 0) return 3000;
      return false;
    }),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ["cached-instagram-accounts", userId] });
  };

  return { ...query, invalidate };
}
